import { RELATIONSHIP_IMPORTANT_OPTIONS } from '../RELATIONSHIP_IMPORTANT_OPTIONS';
import { RelationshipImportantOptionIdType } from '../types';

export const getRelationshipImportantTitleById = (
  id: RelationshipImportantOptionIdType | null | undefined,
): string | null => {
  if (!id) return null;
  return (
    RELATIONSHIP_IMPORTANT_OPTIONS.find((option) => option.id === id)?.title ||
    null
  );
};

const DEFAULT: RelationshipImportantOptionIdType = 'trust_honesty';
export const getRelationshipImportantIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): RelationshipImportantOptionIdType | null => {
  const id = RELATIONSHIP_IMPORTANT_OPTIONS.find(
    (option) => option.title === title,
  )?.id;
  if (id) {
    return id;
  }
  if (withDefault) {
    return DEFAULT;
  }
  return null;
};
